import React, { useState } from 'react';
import axios from 'axios';

function APISevenForm() {
  const [fusions, setFusions] = useState([
    { brand_name: '', celeb_name: '', collab_details: '' }
  ]);
  const [mode, setMode] = useState('dark');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [responseUrl, setResponseUrl] = useState('');

  const handleFusionChange = (index, event) => {
    const values = [...fusions];
    values[index][event.target.name] = event.target.value;
    setFusions(values);
  };

  const handleAddFusion = () => {
    setFusions([...fusions, { brand_name: '', celeb_name: '', collab_details: '' }]);
  };

  const handleModeChange = (event) => {
    setMode(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    try {
      const res = await axios.post(
        'https://ai-api.fuselight.com/create_deck',
        {
          mode: mode,
          input_list: fusions
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      setResponseUrl(res.data.url);
    } catch (error) {
      console.error('Error generating pitch deck:', error);
      setErrorMessage('Failed to generate pitch deck. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="pitch-deck-container">
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <label>Mode:</label>
          <select value={mode} onChange={handleModeChange}>
            <option value="dark">Dark</option>
            <option value="light">Light</option>
          </select>
        </div>
        {fusions.map((fusion, index) => (
          <div key={index} className="fusion-inputs">
            <div className="form-row">
              <input
                type="text"
                name="brand_name"
                value={fusion.brand_name}
                onChange={(event) => handleFusionChange(index, event)}
                placeholder="Brand Name"
                required
              />
              <input
                type="text"
                name="celeb_name"
                value={fusion.celeb_name}
                onChange={(event) => handleFusionChange(index, event)}
                placeholder="Celebrity Name"
                required
              />
            </div>
            <div className="form-row">
              <textarea
                name="collab_details"
                value={fusion.collab_details}
                onChange={(event) => handleFusionChange(index, event)}
                placeholder="Collab Details"
                required
              />
            </div>
          </div>
        ))}
        <div className="form-row">
          <button type="button" onClick={handleAddFusion}>Add Another Fusion</button>
          <button type="submit">Generate Pitch Deck</button>
        </div>
      </form>

      {isLoading && <div className="loading-message">Loading...</div>}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      {responseUrl && <div className="response-url">Pitch Deck URL: <a href={responseUrl} target="_blank" rel="noopener noreferrer">{responseUrl}</a></div>}
    </div>
  );
}

export default APISevenForm;
